import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import Paragraph from "../Paragraph";
import { classes } from "../utils/classes";
import Heading from "../Heading";

export const ContactParagraph = ({
	className = "",
	type = 1,
	center = true,
	children,
	...props
}) => (
	<Paragraph
		Tag="div"
		center={center}
		className={classes(`contact-paragraph-type-${type}`, className)}
		{...props}
	>
		{children}
	</Paragraph>
);

ContactParagraph.propTypes = {
	className: string,
	type: oneOf([1, 2, 3]),
	center: bool,
	children: node.isRequired,
};

export const ContactTitle = ({ className = "", type = 1, center = true, children, ...props }) => (
	<Heading
		Tag="div"
		center={center}
		className={classes(`contact-title-type-${type}`, className)}
		{...props}
	>
		{children}
	</Heading>
);

ContactTitle.propTypes = {
	className: string,
	type: oneOf([1, 2]),
	center: bool,
	children: node.isRequired,
};
